import { generateContext } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import React, { useContext } from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'

const { StateContext, Provider } = generateContext()
export const useLinkTreeItemsState = () => useContext(StateContext)
export const useLinkTreeItems = () => useLinkTreeItemsState().linkTreeItems

const QUERY = gql`
  query LinkTreeItems($filter: LinkTreeItemFilter) {
    linkTreeItems(filter: $filter, sort: { field: ORDINATION, type: ASC }) {
      id
      icon
      url
      label
      ordination
      enabled
      token
      configuration
      isDefault
    }
  }
`

const LinkTreeItemsLoader = ({ children }) => {
  const { id } = useModalData()
  const { data, ...state } = useQuery(QUERY, {
    variables: { filter: { linkTreeId: id, includeDisabled: true } },

    client: generalClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default LinkTreeItemsLoader
